import { loadAuthSession } from './authSession';

/** Google Identity Services OAuth access token (not a Firebase JWT). */
export function looksLikeGoogleAccessToken(token: string): boolean {
  return token.startsWith('ya29.') || token.startsWith('gcp_');
}

/**
 * GIS access token from App prop, then persisted auth session (localStorage).
 * Never returns Firebase ID tokens or other non-GIS values.
 */
export function getEffectiveGoogleAccessToken(prop?: string | null): string | null {
  const trimmed = prop?.trim();
  if (trimmed && looksLikeGoogleAccessToken(trimmed)) return trimmed;
  const session = loadAuthSession()?.accessToken?.trim();
  if (session && looksLikeGoogleAccessToken(session)) return session;
  return null;
}
